import { create } from 'zustand';

interface ReferralStore {
  referralCode: string | null;
}

interface ReferralStoreActions {
  setReferralCode: (code: string) => void;
  clearReferralCode: () => void;
}

export const useReferralStore = create<ReferralStore & ReferralStoreActions>()(
  (set) => ({
    referralCode: null,
    setReferralCode: (code: string) => set({ referralCode: code }),
    clearReferralCode: () => set({ referralCode: null }),
  }),
);
